import React, { useEffect, useState, useMemo } from "react";
import { connect } from "react-redux";
import { getPermissions, addPermissions, } from "./UserPermissions.actions";
import { getUserRes } from "../../AddUser/user.actions";
import { setHeading } from "../../../accounts/account.actions";
import { Row, Col, Form, Container } from "react-bootstrap";
import { GlobalSpinner } from "../../../../../global/globalFunctions";
import Swal from "sweetalert";
import Select from "react-select";
import Button from "@mui/material/Button";
import SendIcon from "@mui/icons-material/Send";
import API from "../../../../../global/api";


const UserPermissions = (props) => {
  const { userList, permissionsList, isFetchingUser, isFetchingPermissionsList } = props;
  const [selectedUser, setSelectedUser] = useState(null);
  const [checkedData, setCheckedData] = useState(new Set());

  const loadUserPermissions = async (userId) => {
    const res = await API.post(`/permission/get-assigned-permission/${userId}`);
    const permissionsArray = res.data?.data?.permission || [];
    const formatted = new Set();

    permissionsArray.forEach((perm) => {
      if (!perm.permissionsName) return;

      if (!perm.permissionsCatName) {
        // Module-only permission
        formatted.add(JSON.stringify({ permissionsName: perm.permissionsName }));
      } else if (!perm.permissionsSubCatName) {
        // Category-level permission
        formatted.add(JSON.stringify({
          permissionsName: perm.permissionsName,
          permissionsCatName: perm.permissionsCatName,
        }));
      } else {
        // Sub-category permission
        formatted.add(JSON.stringify({
          permissionsName: perm.permissionsName,
          permissionsCatName: perm.permissionsCatName,
          permissionsSubCatName: perm.permissionsSubCatName,
        }));
      }
    });

    setCheckedData(formatted);
  };

  const togglePermission = (permissionObj, isChecked, module) => {
    setCheckedData((prev) => {
      const updated = new Set(prev);

      const key = JSON.stringify(permissionObj);

      if (isChecked) {
        updated.add(key);

        // ✅ If sub-category selected → auto select parent category
        if (permissionObj.permissionsSubCatName) {
          const parentKey = JSON.stringify({
            permissionsName: module.permissionsName,
            permissionsCatName: permissionObj.permissionsCatName,
          });

          updated.add(parentKey);
        }
      } else {
        updated.delete(key);

        // ❌ If sub removed → check if no more sub exists → remove parent
        if (permissionObj.permissionsSubCatName) {
          const hasOtherSubs = [...updated].some((item) => {
            const parsed = JSON.parse(item);
            return (
              parsed.permissionsName === module.permissionsName &&
              parsed.permissionsCatName === permissionObj.permissionsCatName &&
              parsed.permissionsSubCatName
            );
          });

          if (!hasOtherSubs) {
            const parentKey = JSON.stringify({
              permissionsName: module.permissionsName,
              permissionsCatName: permissionObj.permissionsCatName,
            });

            updated.delete(parentKey);
          }
        }
      }

      return updated;
    });
  };

  const toggleModule = (module, isChecked) => {
    setCheckedData((prev) => {
      const updated = new Set(prev);

      // ✅ Add/remove the module-level key itself
      const moduleKey = JSON.stringify({
        permissionsName: module.permissionsName,
      });
      if (isChecked) updated.add(moduleKey);
      else updated.delete(moduleKey);

      module.permission_cats?.forEach((cat) => {
        const categoryKey = JSON.stringify({
          permissionsName: module.permissionsName,
          permissionsCatName: cat.permissionsCatName,
        });
        if (isChecked) updated.add(categoryKey);
        else updated.delete(categoryKey);

        cat.permissionSubCats?.forEach((sub) => {
          const subKey = JSON.stringify({
            permissionsName: module.permissionsName,
            permissionsCatName: cat.permissionsCatName,
            permissionsSubCatName: sub.permissionsSubCatName,
          });
          if (isChecked) updated.add(subKey);
          else updated.delete(subKey);
        });
      });

      return updated;
    });
  };

  useEffect(() => {
    props.getUserRes();
    props.getPermissions();
    props.setHeading("Permission");
  }, []);

  useEffect(() => {
    if (selectedUser) {
      loadUserPermissions(selectedUser);
    }
  }, [selectedUser]);

  const handleSuccess = () => {
    Swal({
      title: "Success",
      text: "Added successfully",
      icon: "success",
      button: "Ok",
    });
  };

  const handleError = () => {
    Swal({
      title: "Error",
      text: "Something Went Wrong",
      icon: "error",
      button: "Ok",
    });
  };

  const checkedMap = useMemo(() => {
    return new Set(checkedData);
  }, [checkedData]);

  const isChecked = (obj) => {
    return checkedMap.has(JSON.stringify(obj));
  };

  const sendData = () => {
    const formattedPermissions = [...checkedData].map((item) =>
      JSON.parse(item)
    );
    props.addPermissions({
      user: selectedUser,
      permission: formattedPermissions,
    },
      handleSuccess,
      handleError
    );
  };

  const usersOptions = userList?.map((user) => ({
    value: user._id,
    label: user.userName,
  })) || [];


  if (isFetchingUser || isFetchingPermissionsList) {
    return (
      <GlobalSpinner />
    );
  }

  return (
    <Container fluid>
      <Form>
        <Row>
          <Col>
            <Form.Group>
              <Form.Label> <b>Select User *</b></Form.Label>
              <Select
                placeholder="Select User"
                options={usersOptions}
                onChange={(e) => setSelectedUser(e.value)}
              />
            </Form.Group>
          </Col>
        </Row>

        {/* PERMISSIONS */}
        <Row style={{ marginTop: "2%" }}>
          {permissionsList?.map((module, moduleIndex) => (
            <Col key={moduleIndex} md={4} style={{ marginBottom: 30 }}>

              {/* MODULE CHECKBOX */}
              <div style={{ marginLeft: "5%" }}>
                <input
                  type="checkbox"
                  checked={isChecked({
                    permissionsName: module.permissionsName,
                  })}
                  onChange={(e) => toggleModule(module, e.target.checked)}
                />
                <label style={{ fontWeight: "bold", marginLeft: 5 }}> {module.permissionsName}</label>
              </div>

              {/* CATEGORY */}
              {module.permission_cats?.map((cat, catIndex) => (
                <div key={catIndex} style={{ marginLeft: "15%" }}>
                  <input
                    type="checkbox"
                    checked={isChecked({
                      permissionsName: module.permissionsName,
                      permissionsCatName: cat.permissionsCatName,
                    })}
                    onChange={(e) => {
                      const isChecked = e.target.checked;
                      togglePermission({
                        permissionsName: module.permissionsName,
                        permissionsCatName: cat.permissionsCatName,
                      },
                        isChecked,
                        module
                      );
                      cat.permissionSubCats?.forEach((sub) => {
                        togglePermission({
                          permissionsName: module.permissionsName,
                          permissionsCatName: cat.permissionsCatName,
                          permissionsSubCatName: sub.permissionsSubCatName,
                        },
                          isChecked,
                          module
                        );
                      });
                    }}
                  />
                  <label style={{ marginLeft: 5 }}>  {cat.permissionsCatName}</label>

                  {/* SUB CATEGORY */}
                  {cat.permissionSubCats?.map((sub, subIndex) => (
                    <div
                      key={subIndex}
                      style={{ marginLeft: "20%" }}
                    >
                      <input
                        type="checkbox"
                        checked={isChecked({
                          permissionsName: module.permissionsName,
                          permissionsCatName: cat.permissionsCatName,
                          permissionsSubCatName: sub.permissionsSubCatName,
                        })}
                        onChange={(e) =>
                          togglePermission({
                            permissionsName: module.permissionsName,
                            permissionsCatName: cat.permissionsCatName,
                            permissionsSubCatName: sub.permissionsSubCatName,
                          },
                            e.target.checked,
                            module
                          )
                        }
                      />
                      <label style={{ marginLeft: 5 }}> {sub.permissionsSubCatName} </label>
                    </div>
                  ))}
                </div>
              ))}
            </Col>
          ))}
        </Row>

        {/* SAVE BUTTON */}
        <div style={{ marginTop: 30 }}>
          <Button
            variant="contained"
            size="large"
            endIcon={<SendIcon />}
            disabled={!selectedUser}
            onClick={sendData}
          >
            SAVE
          </Button>
        </div>

      </Form>
    </Container>
  );
};

const mapStateToProps = (state) => ({
  isFetchingUser: state.UserReducer.isFetchingUser,
  userList: state.UserReducer.userList,
  isFetchingPermissionsList: state.permissionReducer.isFetchingPermissionsList,
  permissionsList: state.permissionReducer.permissionsList,
});

const mapDispatchToProps = (dispatch) => ({
  getUserRes: () => dispatch(getUserRes()),
  getPermissions: () => dispatch(getPermissions()),
  addPermissions: (data, success, error) => dispatch(addPermissions(data, success, error)),
  setHeading: (data) => dispatch(setHeading(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserPermissions);